import script from "./TransmissionsCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransmissionsCreate.vue?vue&type=script&setup=true&lang=ts"

import "./TransmissionsCreate.vue?vue&type=style&index=0&id=58d650eb&lang=scss"

const __exports__ = script;

export default __exports__